import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiService } from 'app/shared/services';
import { CONTROLLERS } from 'app/shared/services/controllers';
import { ApiResponse, Client, Site } from 'app/shared/types';
import { environment } from 'environment/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthClientService extends BaseApiService<
  ApiResponse<Client[]>,
  ApiResponse<{ client: Client }>,
  ApiResponse<{ id: string }>
> {
  constructor(public override http: HttpClient) {
    super(http, environment.authApiBaseUrl);
  }

  public override controllerName(): string {
    return CONTROLLERS.clients;
  }

  public getSitesByClient(clientId: string | null): Observable<ApiResponse<Site[]>> {
    return this.http.get<ApiResponse<Site[]>>(`${this.api}/${this.controllerName()}/${clientId}/sites`);
  }
}
